var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.headerIconClass},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.handleOpen}},[_c('img',{ref:"headerIconImg",staticStyle:{"margin":"0"},attrs:{"src":_vm.staffInfo.PictureUrl}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9894d328","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/MainToolBbarStaff.vue
// module id = null
// module chunks = 